import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PatientAnalytics } from '../../api/services/analytics';

interface AnalyticsState {
  patientAnalytics: {
    data: PatientAnalytics | null;
    loading: boolean;
    error: string | null;
  };
}

const initialState: AnalyticsState = {
  patientAnalytics: {
    data: null,
    loading: false,
    error: null,
  },
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    fetchPatientAnalytics: state => {
      state.patientAnalytics.loading = true;
      state.patientAnalytics.error = null;
    },
    fetchPatientAnalyticsSuccess: (state, action: PayloadAction<PatientAnalytics>) => {
      state.patientAnalytics.data = action.payload;
      state.patientAnalytics.loading = false;
      state.patientAnalytics.error = null;
    },
    fetchPatientAnalyticsFailure: (state, action: PayloadAction<string>) => {
      state.patientAnalytics.loading = false;
      state.patientAnalytics.error = action.payload;
    },
  },
});

export const { fetchPatientAnalytics, fetchPatientAnalyticsSuccess, fetchPatientAnalyticsFailure } =
  analyticsSlice.actions;

export default analyticsSlice.reducer;
